import React, { FC, PropsWithChildren } from 'react';

import { Product } from 'src/api/@generated/backend';

import { DataLayerWrapper } from 'src/components/data-layer-wrapper/data-layer-wrapper';
import { selectProductIndex } from 'src/state/order/selectors';
import { useAppSelector } from 'src/state/thunk-api';
import { DataLayerUtils } from 'src/utils/data-layer-utils';

interface Props {
  orderNumber: string;
  product: Product;
}

export const DataLayerPurchaseWrapper: FC<PropsWithChildren<Props>> = (props) => {
  const { orderNumber, product, children } = props;
  const selectedProductIndex = useAppSelector(selectProductIndex(product));

  return (
    <DataLayerWrapper
      pushToDataLayer={() => DataLayerUtils.setPurchaseDataLayer(orderNumber, product, selectedProductIndex)}
    >
      {children}
    </DataLayerWrapper>
  );
};
